export const state = {
    bookmarks: []
}
